export async function checkAccess(): Promise<boolean> {

    const token = new URLSearchParams(window.location.search).get("token");

    if (!token) {
        return false;
    }

    const OWF_URL = import.meta.env.VITE_OWF_URL;

    const res = await fetch(
        `${OWF_URL}/Home/ValidateKbAccess?token=${token}`
    );

    if (!res.ok) return false;

    return true;
}
